import { render, staticRenderFns } from "./ErrorAutenticate.vue?vue&type=template&id=56a7d5fa&lang=pug&"
import script from "./ErrorAutenticate.vue?vue&type=script&lang=js&"
export * from "./ErrorAutenticate.vue?vue&type=script&lang=js&"
import style0 from "./ErrorAutenticate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports